var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GO_LOGO",
    "data-name": "GO LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.577,
    height: 130.048,
    viewBox: "0 0 152.577 130.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 152.577,
    height: 130.048,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M49.18,113.621A5.25,5.25,0,0,1,45.3,114.99H26.438q-5.175,0-5.173-5.324V62.2q0-5.322,5.173-5.323H45.3a5.246,5.246,0,0,1,3.878,1.369A5.355,5.355,0,0,1,50.549,62.2v47.464a5.354,5.354,0,0,1-1.369,3.956m-7.3-49.365H29.937v43.357H41.879Z",
    transform: "translate(1.196 3.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M93.024,58.229V29.553c0-.557.012-1.19.039-1.9a17,17,0,0,1,.19-2.053q.151-1.139.3-2.358L86.027,52.9H81.614L74.084,23.24q.074,1.217.229,2.358.15.989.227,2.053t.076,1.9V58.229H66.25V.117h8.214l9.128,32.1a2.183,2.183,0,0,1,.076.646,5.2,5.2,0,0,0,.076.875,8.873,8.873,0,0,0,.077,1.143,8.28,8.28,0,0,1,.074-1.143,6.405,6.405,0,0,1,.153-1.521L93.176.117h8.214V58.229Z",
    transform: "translate(3.726 0.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M106.072,58.229V.117h23.884V7.8H114.742V24.762h13.084v7.53H114.742V50.546h15.44v7.683Z",
    transform: "translate(5.965 0.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M87.58,114.274h24.112v-7.683H96.253V88.337h13.081v-7.53H96.253V68.027H87.58Z",
    transform: "translate(4.925 3.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M135.668,87.957h2.966q5.173-.151,5.175-5.323V68.027h-8.673v13.95h-8.517v5.256l9.582,27.042h9.052v-.3Z",
    transform: "translate(7.121 3.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 8.671,
    height: 46.247,
    transform: "translate(122.632 71.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M28.031,25.718H12.818v7.377h6.466v11.87h8.747Z",
    transform: "translate(0.721 1.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M8.672,7.531H20.005V17.8h8.747V5.423q0-5.268-5.324-5.27H5.248Q0,.153,0,5.479V46.4H8.672Z",
    transform: "translate(0 0.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M150.928,61.2H78.974l-6.541,39.857L72.2,106l-.228-4.943L53.573,0H44.9L35.326,49.377H0v7.646l42.555.037L49.1,17.2l.228-4.943.228,4.943L68.06,118.089h8.672l9.473-49.2h64.723v-2.36c0-3.547.055-2.628,0-5.322",
    transform: "translate(0 0)",
    fill: "#da1a35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M87.591,115.63h3.676c.008,0,.012,0,.012.011v.353c0,.006,0,.011-.012.011H87.954v2.956h1.465c.006,0,.011,0,.011.008v.354s0,.005-.011.005H87.954v3.324h3.312c.008,0,.012,0,.012.011v.354c0,.006,0,.01-.012.01H87.591c-.006,0-.011,0-.011-.01v-7.376a.009.009,0,0,1,.011-.011",
    transform: "translate(4.925 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M93.673,115.635h1.216a1.214,1.214,0,0,1,.939.369,1.165,1.165,0,0,1,.254.379,1.252,1.252,0,0,1,.09.452c.006,0,.01,0,.01.011v.448c0,.006,0,.008-.01.008h-.364c-.006,0-.01,0-.01-.008v-.428a.822.822,0,0,0-.489-.789.85.85,0,0,0-.373-.073H93.661a.82.82,0,0,0-.8.8v1.557a.8.8,0,0,0,.285.587.779.779,0,0,0,.363.182l.13.02.109,0h1.123a1.269,1.269,0,0,1,.773.212,1.1,1.1,0,0,1,.348.375,1.066,1.066,0,0,1,.125.27,1.361,1.361,0,0,1,.053.342.008.008,0,0,1,.01.01v1.482A1.2,1.2,0,0,1,95,123.025H93.673a1.187,1.187,0,0,1-.962-.5,1.217,1.217,0,0,1-.223-.691v-.464c0-.006,0-.01.011-.01h.354c.006,0,.011,0,.011.01v.484a.822.822,0,0,0,.8.8h1.347a.823.823,0,0,0,.8-.8v-.025l-.01-.017v-1.438a.828.828,0,0,0-.427-.758.881.881,0,0,0-.442-.1H93.735a.485.485,0,0,0-.074.005,1.246,1.246,0,0,1-.752-.28,1.211,1.211,0,0,1-.421-.905v-1.51a1.2,1.2,0,0,1,1.185-1.189",
    transform: "translate(5.201 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M98.555,115.635H99.77a1.216,1.216,0,0,1,.941.369,1.165,1.165,0,0,1,.254.379,1.272,1.272,0,0,1,.089.452c.007,0,.01,0,.01.011v1c0,.007,0,.011-.01.011h-.364c-.006,0-.01,0-.01-.011v-.982a.825.825,0,0,0-.488-.789.858.858,0,0,0-.374-.073H98.543a.825.825,0,0,0-.8.8v5.053a.825.825,0,0,0,.8.8H99.89a.8.8,0,0,0,.638-.334.8.8,0,0,0,.161-.467v-1.038c.005-.007.007-.011.012-.011h.353c.007,0,.01.006.01.011v1.018a1.18,1.18,0,0,1-.524.981,1.168,1.168,0,0,1-.659.207H98.555a1.185,1.185,0,0,1-.961-.5,1.211,1.211,0,0,1-.224-.691v-5.013a1.2,1.2,0,0,1,1.185-1.189",
    transform: "translate(5.476 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M105.488,121.015l.488,2.014-.011.006H105.6a2.239,2.239,0,0,1-.1-.411q-.716-2.9-.841-3.423-.043-.16-.529-2.164l-1.279,5.24c-.037.137-.1.39-.186.752l-.012.006h-.362l-.011-.006q1.069-4.382,1.513-6.206c.207-.845.319-1.3.337-1.359Z",
    transform: "translate(5.752 6.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M107.2,115.743h2.461a1.175,1.175,0,0,1,.961.52,1.23,1.23,0,0,1,.2.665V118.4a1.173,1.173,0,0,1-.493.941,1.23,1.23,0,0,1-.685.228l-.061-.005h-2.027v3.45a.008.008,0,0,1-.01.009H107.2c-.007,0-.012,0-.012-.009v-7.256a.01.01,0,0,1,.012-.011m.357.37V119.2h1.979c.024,0,.059,0,.1-.005l.009.005a.833.833,0,0,0,.557-.229.8.8,0,0,0,.248-.565V116.9a.8.8,0,0,0-.316-.623.775.775,0,0,0-.464-.166Z",
    transform: "translate(6.028 6.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M112.1,115.63h3.678c.006,0,.01,0,.01.011v.353c0,.006,0,.011-.01.011h-3.314v2.956h1.464c.007,0,.012,0,.012.008v.354s0,.005-.012.005h-1.464v3.324h3.314c.006,0,.01,0,.01.011v.354a.008.008,0,0,1-.01.01H112.1c-.007,0-.012,0-.012-.01v-7.376c0-.007,0-.011.012-.011",
    transform: "translate(6.304 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M119.952,115.64h2.5a1.191,1.191,0,0,1,.977.53,1.241,1.241,0,0,1,.207.675v1.489a1.193,1.193,0,0,1-.5.957,1.283,1.283,0,0,1-.7.228l-.062-.005h-1l2.259,3.5v.01H123.2q-.025-.021-.577-.9-.093-.128-1.678-2.612h-.627v3.5c0,.006,0,.01-.011.01h-.353c-.006,0-.011,0-.011-.01V115.65c0-.006,0-.01.011-.01m.363.374v3.136h2c.027,0,.064,0,.109,0l.011,0a.825.825,0,0,0,.561-.232.8.8,0,0,0,.26-.571v-1.534a.8.8,0,0,0-.322-.628.813.813,0,0,0-.468-.17Z",
    transform: "translate(6.745 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M126.018,115.64h1.3a1.2,1.2,0,0,1,1.024.571,1.241,1.241,0,0,1,.171.613v5.018a1.2,1.2,0,0,1-1.183,1.183h-1.327a1.179,1.179,0,0,1-1.183-1.175v-5.027a1.194,1.194,0,0,1,.515-.972,1.224,1.224,0,0,1,.678-.212m-.829,1.172v.027l-.011.015v4.914a.854.854,0,0,0,.518.835.8.8,0,0,0,.312.062h1.225a.866.866,0,0,0,.66-.232.856.856,0,0,0,.266-.671V116.9a.851.851,0,0,0-.546-.852,1.193,1.193,0,0,0-.406-.052h-1.089a.9.9,0,0,0-.6.176.8.8,0,0,0-.326.638",
    transform: "translate(7.02 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M130.945,115.64h1.3a1.2,1.2,0,0,1,1.025.571,1.25,1.25,0,0,1,.17.613v5.018a1.2,1.2,0,0,1-1.183,1.183h-1.325a1.2,1.2,0,0,1-.988-.529,1.211,1.211,0,0,1-.2-.645v-5.027a1.2,1.2,0,0,1,.514-.972,1.233,1.233,0,0,1,.68-.212m-.83,1.172v.027l-.011.015v4.914a.853.853,0,0,0,.52.835.8.8,0,0,0,.312.062h1.225a.87.87,0,0,0,.659-.232.852.852,0,0,0,.266-.671V116.9a.853.853,0,0,0-.546-.852,1.19,1.19,0,0,0-.4-.052h-1.092a.891.891,0,0,0-.6.176.8.8,0,0,0-.327.638",
    transform: "translate(7.297 6.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M134.678,115.1h.011s.5,1.511,1.506,4.524q.955,2.872.955,2.882h.011q.067-.208,1.621-4.613.9-2.549.981-2.794h.01v7.957c0,.006,0,.012-.01.012h-.342s-.006-.005-.006-.012v-5.864h-.005q-.046.147-1.688,4.789-.561,1.584-.561,1.595h-.011l-1.579-4.738q-.206-.61-.544-1.64h-.006v5.859a.01.01,0,0,1-.011.012h-.321a.01.01,0,0,1-.011-.012Z",
    transform: "translate(7.574 6.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M142.141,115.635h1.217a1.207,1.207,0,0,1,.938.369,1.172,1.172,0,0,1,.256.379,1.294,1.294,0,0,1,.088.452c.007,0,.012,0,.012.011v.448c0,.006,0,.008-.012.008h-.362c-.007,0-.011,0-.011-.008v-.428a.825.825,0,0,0-.488-.789A.862.862,0,0,0,143.4,116h-1.273a.823.823,0,0,0-.8.8v1.557a.8.8,0,0,0,.285.587.785.785,0,0,0,.363.182l.13.02.11,0h1.121a1.271,1.271,0,0,1,.774.212,1.27,1.27,0,0,1,.472.645,1.4,1.4,0,0,1,.052.342c.007,0,.012,0,.012.01v1.482a1.2,1.2,0,0,1-1.185,1.188h-1.325a1.186,1.186,0,0,1-.96-.5,1.209,1.209,0,0,1-.223-.691v-.464c0-.006,0-.01.008-.01h.354c.007,0,.012,0,.012.01v.484a.82.82,0,0,0,.8.8h1.345a.825.825,0,0,0,.8-.8v-.025l-.011-.017v-1.438a.827.827,0,0,0-.428-.758.878.878,0,0,0-.439-.1h-1.2a.468.468,0,0,0-.072.005,1.252,1.252,0,0,1-.754-.28,1.209,1.209,0,0,1-.419-.905v-1.51a1.2,1.2,0,0,1,1.183-1.189",
    transform: "translate(7.927 6.503)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGologo);
export default __webpack_public_path__ + "static/media/GO LOGO.86f691b96b4923d7a7e6414c53b88c9d.svg";
export { ForwardRef as ReactComponent };